import React from 'react';
import { BrandLogo } from './BrandLogo';
export function SiteFooter() {
  return <footer className="mt-24 border-t border-white/10" data-id="element-45" data-mp="3r8j5p2ritcpa">
      <div className="mx-auto flex max-w-5xl justify-center px-6 py-10" data-id="element-46" data-mp="3r91a4moc6x8a">
        <BrandLogo className="w-40 opacity-80 sm:w-48" data-id="element-47" data-mp="3mghn6z3repqt" />
      </div>
    </footer>;
}